import flatpickr from "flatpickr";
import flatpickrJp from "flatpickr/dist/l10n/ja";
import MonthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

// 日付毎に
function onDayCreate(dObj, dStr, fp, dayElem) {
    // 土日無効・クラス付与
    const dayOfWeek = dayElem.dateObj.getDay();
    switch (dayOfWeek) {
        case 0:
            dayElem.classList.add('sunday');
            break;
        case 6:
            dayElem.classList.add('saturday');
            break;
    }
    // 祝日無効・クラス付与
    // var ymd = YMD(dayElem.dateObj);
    // if( ymd in holidays ) $(dayElem).addClass('flatpickr-disabled jp-holiday');
}

function initDateMode(item) {
    const dateData = {
        locale: "ja",
        onDayCreate: onDayCreate,
        dateFormat: 'Y/m/d',
        allowInput: true
    };

    var isFlatpickerVal = item.attributes;
    if (isFlatpickerVal["data-date-format"]) {
        dateData.dateFormat = isFlatpickerVal["data-date-format"].value.toString();
    }
    if (isFlatpickerVal["data-enable-time"]) {
        dateData.enableTime = true;
        dateData.dateFormat = isFlatpickerVal["data-date-format"].value.toString() + " H:i";
    }
    if (isFlatpickerVal["data-minDate"]) {
        dateData.minDate = isFlatpickerVal["data-minDate"].value.toString();
        dateData.dateFormat = isFlatpickerVal["data-date-format"].value.toString();
    }
    if (isFlatpickerVal["data-maxDate"]) {
        dateData.maxDate = isFlatpickerVal["data-maxDate"].value.toString();
        dateData.dateFormat = isFlatpickerVal["data-date-format"].value.toString();
    }
    if (isFlatpickerVal["data-default-date"]) {
        dateData.defaultDate = isFlatpickerVal["data-default-date"].value.toString();
        dateData.dateFormat = isFlatpickerVal["data-date-format"].value.toString();
    }
    if (isFlatpickerVal["data-multiple-date"]) {
        dateData.mode = "multiple";
        dateData.dateFormat = isFlatpickerVal["data-date-format"].value.toString();
    }
    if (isFlatpickerVal["data-range-date"]) {
        dateData.mode = "range";
        dateData.dateFormat = isFlatpickerVal["data-date-format"].value.toString();
    }
    if (isFlatpickerVal["data-date-wrap"]) {
        dateData.wrap = true;
    }
    if (isFlatpickerVal["data-inline-date"]) {
        dateData.inline = true;
        dateData.defaultDate = isFlatpickerVal["data-default-date"].value.toString();
        dateData.dateFormat = isFlatpickerVal["data-date-format"].value.toString();
    }
    if (isFlatpickerVal["data-month-select"]) {
        dateData.plugins = [
            new MonthSelectPlugin({
                dateFormat: "Ym",
            })
        ]
    }
    flatpickr(item, dateData);
}

function initTimePicker(item) {
    var timeData = {};
    var isTimepickerVal = item.attributes;
    if (isTimepickerVal["data-time-basic"]) {
        timeData.enableTime = true;
        timeData.noCalendar = true;
        timeData.dateFormat = "H:i";
    }
    if (isTimepickerVal["data-time-hrs"]) {
        timeData.enableTime = true;
        timeData.noCalendar = true;
        timeData.dateFormat = "H:i";
        timeData.time_24hr = true;
    }
    if (isTimepickerVal["data-min-time"]) {
        timeData.enableTime = true;
        timeData.noCalendar = true;
        timeData.dateFormat = "H:i";
        timeData.minTime = isTimepickerVal["data-min-time"].value.toString();
    }
    if (isTimepickerVal["data-max-time"]) {
        timeData.enableTime = true;
        timeData.noCalendar = true;
        timeData.dateFormat = "H:i";
        timeData.minTime = isTimepickerVal["data-max-time"].value.toString();
    }
    if (isTimepickerVal["data-default-time"]) {
        timeData.enableTime = true;
        timeData.noCalendar = true;
        timeData.dateFormat = "H:i";
        timeData.defaultDate = isTimepickerVal["data-default-time"].value.toString();
    }
    if (isTimepickerVal["data-time-inline"]) {
        timeData.enableTime = true,
        timeData.noCalendar = true,
        timeData.defaultDate = isTimepickerVal["data-time-inline"].value.toString();
        timeData.inline = true;
    }
    flatpickr(item, timeData);
}

// flatpickrの初期化関数を定義
export function initFlatPicker(elem) {
    const flatpickrItems = elem.querySelectorAll("[data-provider]");
    Array.from(flatpickrItems).forEach(function (item) {
        if (item.getAttribute("data-provider") === "flatpickr") {
            initDateMode(item);
        } else if (item.getAttribute("data-provider") === "timepickr") {
            initTimePicker(item);
        }
    });
}
initFlatPicker(document);
